<template>
  <div>
    <div>
      <div class="searchArea">

        <!-- <a-range-picker v-model:value="inputs.patroltime" :placeholder="['应巡开始时间','应巡结束时间']" :locale="locale" /> -->

        <a-input v-model:value="inputs.name" placeholder="患者名称" />
        <!-- <a-date-picker v-model:value="inputs.date" valueFormat="YYYY-MM-DD" placeholder="日期" /> -->
        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
        <a-button style="margin-left: 10px" type="primary" @click="showModal()">
          <template #icon>
            <PlusOutlined />
          </template>
          新增预约
        </a-button>
      </div>
      <a-collapse v-if="data1.length || data2.length || data3.length" v-model:activeKey="activeKey">
        <a-collapse-panel v-if="data1.length" key="看诊中" header="看诊中">
          <a-table class="ant-table-striped" :columns="columns" :data-source="data1" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :scroll="{ y: 550 }" :pagination="{ pageSize: 8, total, current }" @change="search">
            <template #operation="{ record }">
              <div class="flex_sa">
                <div class="editable-row-operations">
                  <span>
                    <a @click="openRecord(record.medicalRecordUuid)">详情</a>
                  </span>
                </div>
              </div>
            </template>
            <template #assistantName="{ record,text ,col}">
              <div>
                <!-- <div>{{record.id}}</div> -->
                <!-- <a-input v-model:value="editableData[record.id][col]" /> -->
                <a-popconfirm v-if="editableData[record.id]" title="是否确认更改" @confirm="update(record)" okText="确认" cancelText="取消" :visible="showChange">
                  <a-select v-if="editableData[record.id]" v-model:value="editableData[record.id]['assistantName']" style="width:150px;text-align: center;" @change="showChange=true">
                    <a-select-option v-for="item in option" :value="item.id">{{ item.name }}</a-select-option>
                  </a-select>
                </a-popconfirm>
                <template v-else>{{ text }}
                  <edit-outlined style="color:#40a9ff" @click="edit(record.id)" />
                </template>
              </div>
            </template>
          </a-table>
        </a-collapse-panel>
        <a-collapse-panel v-if="data2.length" key="候诊中" header="候诊中">
          <a-table class="ant-table-striped" :columns="columns" :data-source="data2" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :scroll="{ y: 550 }" :pagination="{ pageSize: $store.state.tableSize, total, current }" @change="search">
            <template #operation="{ record }">
              <div class="flex_sa">
                <div class="editable-row-operations">
                  <span>
                    <a @click="start(record)">开始看诊</a>
                  </span>
                </div>
                <div class="editable-row-operations">
                  <span>
                    <a-popconfirm title="是否确认删除" @confirm="handleDelete(record)" okText="确认" cancelText="取消">
                      <a>删除</a>
                    </a-popconfirm>
                  </span>
                </div>
              </div>
            </template>
            <template #assistantName="{ record,text ,col}">
              <div>
                <!-- <div>{{record.id}}</div> -->
                <!-- <a-input v-model:value="editableData[record.id][col]" /> -->
                <a-popconfirm v-if="editableData[record.id]" title="是否确认更改" @confirm="update(record)" okText="确认" cancelText="取消" :visible="showChange">
                  <a-select v-model:value="editableData[record.id]['assistantName']" style="width:150px;text-align: center;" @change="showChange=true">
                    <a-select-option v-for="item in option" :value="item.id">{{ item.name }}</a-select-option>
                  </a-select>
                </a-popconfirm>
                <template v-else>{{ text }}
                  <edit-outlined style="color:#40a9ff" @click="edit2(record.id)" /></template>
              </div>
            </template>
          </a-table>
        </a-collapse-panel>
        <a-collapse-panel v-if="data3.length" key="已完成" header="已完成">
          <a-table class="ant-table-striped" :columns="columns" :data-source="data3" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :scroll="{ y: 550 }" :pagination="{ pageSize: $store.state.tableSize, total, current }" @change="search">
            <template #operation="{ record }">
              <div class="flex_sa">
                <div class="editable-row-operations">
                  <span>
                    <a @click="openRecord(record.medicalRecordUuid)">详情</a>
                  </span>
                </div>
              </div>
            </template>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <addTodayConsultation v-model="visible" @reSearch="search('')" @openRecordModal="openRecordModal" />
    <a-modal v-model:visible="visible2" title="查看" okText="确认" cancelText="取消" @ok="handleOpenRecord" width="20vw">
      是否直接打开病例
      <h5 style="color:#999;margin-top: 10px;">弹窗可能被浏览器拦截，请检查地址栏右侧手动允许弹窗</h5>
    </a-modal>
  </div>
</template>

<style scoped>
.ant-collapse {
  max-height: 72vh;
  overflow: auto;
}
</style>


<script>
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined,
  EditOutlined,
  SmileOutlined,
} from "@ant-design/icons-vue";
import { notification, Button } from 'ant-design-vue';
import { reactive, h } from "vue";
import { cloneDeep } from "lodash-es";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search, Delete, SearchEmployee, Update, GenerateRecord, Start } from "/src/api/todayConsultation.js";
import { pinyin } from 'pinyin-pro';
import getAutoPrescription from '/src/components/autoPrescription/getAutoPrescription.vue';
import addTodayConsultation from '/src/components/todayConsultation/addTodayConsultation.vue';

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    DownloadOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    getAutoPrescription,
    FormOutlined,
    addTodayConsultation,
    EditOutlined,
    SmileOutlined,
  },
  name: "今日看诊",
  data() {
    return {
      visible: false,
      visible2: false,
      active: undefined,
      id: undefined,
      selectedRow: {},
      newRecordData: undefined,
      showChange: false,
      total: 0,
      current: 1,
      // pageSize: 10,
      inputs: {
        name: undefined,
        date: undefined,
      },
      modelInput: {
        name: undefined,
        gender: undefined,
        nameInitial: undefined,
        isStandard: true,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      option: [],
      columns: [
        {
          title: "时间段",
          key: "period",
          dataIndex: "period",
          width: "20%",
          slots: {
            customRender: "period"
          }
        },
        {
          title: "患者",
          key: "customerName",
          dataIndex: "customerName",
          ellipsis: true,
          width: "20%",
          slots: {
            customRender: "customerName"
          },
        },
        {
          title: "电话",
          width: "20%",
          key: "gender",
          dataIndex: "gender",
          slots: {
            customRender: "gender"
          }
        },
        {
          title: "助理",
          key: "assistantName",
          dataIndex: "assistantName",
          // ellipsis: true,
          width: "20%",
          slots: {
            customRender: "assistantName"
          }
        },

        {
          title: "操作",
          dataIndex: "operation",
          width: "20%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],
      data1: [],
      data2: [],
      data3: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
          this.selectedRows = selectedRows;
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
        }
      },
      activeKey: ["看诊中"],
      editableData: reactive({}),
      selectedRows: {}
      // doExcel: doExcel
    };
  },
  created() { },
  mounted() {
    this.search("");
    this.searchEmployee()
  },
  activated() {
    if (localStorage.getItem("refrashProject") == "true") {
      // this.search(1);
    }
    localStorage.setItem("refrashProject", false);
  },
  methods: {

    showModal() {
      this.visible = true;
    },
    closeModal(value) {
      this[value] = false;
    },
    getAutoPrescription(record, col) {
      this.visible2 = true
      record.category = col
      this.selectedRow = { ...record }
    },
    linkDisease(record) {
      this.visible3 = true
      this.selectedRow = { ...record }
    },
    Detail(record) {
      this.visible4 = true
      this.selectedRow = { ...record }
    },
    async start(record) {
      console.log(record);

      let res = await GenerateRecord({ appointmentUuid: record.uuid })
      let medicalRecordUuid = res.data.uuid
      await Start({ uuid: medicalRecordUuid, operation: "开始看诊" })
      this.$message.success("开始看诊成功", function () { });
      await this.search("");
      notification.open({
        message: "成功开始看诊",
        description: `患者${record.customerName}开始看诊,是否打开病例？`,
        icon: h(SmileOutlined, { style: 'color: #108ee9' }),
        duration: 5,
        btn: h(
          Button,
          {
            type: 'primary',
            size: 'small',
            onClick: () => this.openRecord(medicalRecordUuid),
          },
          '打开',
        ),
      });
      return medicalRecordUuid
    },
    openRecord(id) {
      window.open("/#/medicalRecord/" + id, "_blank")
    },
    //新建完直接开始看诊
    async handleOpenRecord() {
      console.log("newData", this.newRecordData);

      let uuid = await this.start(this.newRecordData)
      this.openRecord(uuid)
      this.visible2 = false
    },
    async openRecordModal(data) {
      this.visible2 = true
      this.newRecordData = data
      console.log("新建返回的newRecordData", data);

    },
    async update(record) {
      console.log(this.editableData[record.id]);
      let data = this.editableData[record.id]

      let res = await Update({ id: data.id, assistantId: data.assistantName })
      if (res.errCode == 0) {
        this.editableData = []
        this.$message.success("修改成功", function () { });
        this.search("");
      }

    },
    async searchEmployee() {
      let res = await SearchEmployee({ position: "医生助理" })
      this.option = res.data.records

    },
    async handleOk() {
      let _this = this;

      let res = await Add(this.modelInput)
      if (res.errCode == 0) {
        _this.$message.success("新建成功", function () { });
        _this.visible = false
      }
    },
    async handleDelete(record) {
      let res = await Delete({ uuid: record.uuid })
      if (res.errCode == 0) {
        this.$message.success("删除成功", function () { });
        this.search("");
      }

    },
    resetForm() {
      this.inputs = {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      }
    },
    async addDisease() {
      this.visible = true;
    },
    async onDelete(id) {
      this.editableData = {}
      let res = await Delete({ id })
      this.data = this.data.filter(function (item) {
        return item.id !== id;
      });
    },
    edit(id) {
      let _data = this.data1;
      this.editableData[id] = cloneDeep(
        _data.filter(item => id === item.id)[0]
      );
    },
    edit2(id) {
      let _data = this.data2;
      this.editableData[id] = cloneDeep(
        _data.filter(item => id === item.id)[0]
      );
      console.log(this.editableData);
    },
    async save(id) {
      let _data = this.data;
      //判断editableData和修改前是否一致，如果一致则不修改
      if (JSON.stringify(this.data.find((item) => item.id == id)) === JSON.stringify(this.editableData[id])) {
        delete this.editableData[id];
        return;
      }
      let params = {
        id: this.editableData[id].id,
        name: this.editableData[id].name,
        nameInitial: this.editableData[id].nameInitial,
        gender: this.editableData[id].gender,
      }
      console.log(params);
      let res = await Update(params)
      if (res.errCode == 0) {
        Object.assign(
          _data.filter(item => id === item.id)[0],
          this.editableData[id]
        );
        delete this.editableData[id];
      }
    },
    cancel(id) {
      delete this.editableData[id];
    },

    async search(pagination) {
      let _this = this;
      this.editableData = {}
      let params = {
        customerName: this.inputs.name,
        date: new Date().toLocaleDateString().split('/').join('-'),
        pageSize: -1,
      };
      if (pagination == "") {
        params.current = 1
      } else {
        params.current = pagination.current
        this.current = pagination.current;
      }

      let res = await Search(params)
      if (res.errCode == 0) {
        if (pagination == "") {
          // this.$message.success("查询成功", function () { });
          this.current = 1;
        }
        this.total = res.data.total;
        if (!res.data?.records) {
          this.data1 = [];
          this.data2 = [];
          this.data3 = [];
          return
        }
        // this.data = res.data.records;
        this.data1 = res.data.records.filter(item => item.tcmStatus
          == "看诊中");
        this.data2 = res.data.records.filter(item => item.tcmStatus
          == "候诊中");
        this.data3 = res.data.records.filter(item => item.tcmStatus
          == "看诊完成");

        //哪个data有先展开哪个
        if (this.data1.length > 0) {
          this.activeKey = ["看诊中"]
        } else if (this.data2.length > 0) {
          this.activeKey = ["候诊中"]
        } else if (this.data3.length > 0) {
          this.activeKey = ["已完成"]
        } else {
          this.activeKey = []
        }
      }
    },



  }
};
</script>